export const CLEAN_FORM = 'fuerzaventas/gestionprecios/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'fuerzaventas/gestionprecios/set-state-form';
export const UPDATE_FIELD_FILTER = 'fuerzaventas/gestionprecios/update-field-filter';
export const RECEIVE_V_LIST = 'fuerzaventas/gestionprecios/receive-v-list';
export const RECEIVE_V_LIST2 = 'fuerzaventas/gestionprecios/receive-v-list2';
export const REQUEST_V_LIST = 'fuerzaventas/gestionprecios/request-v-list';
export const ERROR_V_LIST = 'fuerzaventas/gestionprecios/error-v-list';
export const SET_MASK = 'fuerzaventas/gestionprecios/set-mask';
export const SET_ORDER = 'fuerzaventas/gestionprecios/set-order';
export const RECEIVE_DATA= 'fuerzaventas/gestionprecios/receibe-data';
export const UPDATE_TABLE_COLUMN= 'fuerzaventas/gestionprecios/update-table-column';
export const SET_PAGE = 'fuerzaventas/gestionprecios/set-page';
export const SET_SELECTED_ROW = 'fuerzaventas/gestionprecios/set-selected-row';
export const CLEAN_DATA2 = 'fuerzaventas/gestionprecios/clean-data2';
export const CLEAR_SELECT= 'fuerzaventas/gestionprecios/clear-select';
export const SET_PAGE_SIZE= 'fuerzaventas/gestionprecios/set-page-size';
export const SET_SELECTED_MULTI= 'fuerzaventas/gestionprecios/set-selected-multi';
